import { makeId } from "../../../helper/util";
import moment from "moment/moment";

// Utility function to sanitize coordinate values to prevent scientific notation issues
const sanitizeCoordinate = (value, isLongitude = false) => {
  if (value === null || value === undefined || value === "") {
    return undefined;
  }

  let numValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numValue) || !isFinite(numValue)) {
    return undefined;
  }

  // Validate coordinate ranges
  if (isLongitude) {
    if (numValue < -180 || numValue > 180) {
      console.warn(`Invalid longitude value: ${numValue}. Must be between -180 and 180.`);
      return undefined;
    }
  } else {
    if (numValue < -90 || numValue > 90) {
      console.warn(`Invalid latitude value: ${numValue}. Must be between -90 and 90.`);
      return undefined;
    }
  }

  // Round to 8 decimal places to match DB precision and prevent scientific notation
  return Math.round(numValue * 100000000) / 100000000;
};

export function packageHasError(poolPackage) {
  if (
    !poolPackage?.pickupAddress ||
    !poolPackage?.pickupContactName ||
    !poolPackage?.pickupContactPhone ||
    !poolPackage?.dropoffAddress ||
    !poolPackage?.dropoffContactName ||
    !poolPackage?.dropoffContactPhone ||
    !poolPackage?.packageTypeId ||
    !poolPackage?.pickupLat ||
    !poolPackage?.pickupLng ||
    !poolPackage?.dropoffLat ||
    !poolPackage?.dropoffLng ||
    !poolPackage?.pickupDate
  )
    return true;
  return false;
}

export const poolPackageTransform = (poolPackages) => {
  return poolPackages.map((poolPackage) => ({
    pickupAddress: poolPackage?.pickupAddress,
    pickupPhysicalAddress: poolPackage?.pickupPhysicalAddress,
    pickupContactName: poolPackage?.pickupContactName,
    pickupContactPhone: poolPackage?.pickupContactPhone,
    pickupContactEmail: poolPackage?.pickupContactEmail,
    pickupStopName: poolPackage?.pickupStopName,
    dropoffAddress: poolPackage?.dropoffAddress,
    dropoffPhysicalAddress: poolPackage?.dropoffPhysicalAddress,
    dropoffContactName: poolPackage?.dropoffContactName,
    dropoffContactPhone: poolPackage?.dropoffContactPhone,
    dropoffStopName: poolPackage?.dropoffStopName,
    packageTypeId: poolPackage?.packageTypeId,
    pickupLat: sanitizeCoordinate(poolPackage?.pickupLat, false),
    pickupLng: sanitizeCoordinate(poolPackage?.pickupLng, true),
    dropoffLat: sanitizeCoordinate(poolPackage?.dropoffLat, false),
    dropoffLng: sanitizeCoordinate(poolPackage?.dropoffLng, true),
    pickupDate: poolPackage?.pickupDate.toDate(),
    note: poolPackage?.note,
    quantity: poolPackage?.quantity,
    shopifyOrderId: poolPackage?.shopifyOrderId
  }));
};
export const newPackage = {
  id: `${new Date().getTime()}${makeId(4)}`,
  pickupAddress: "",
  pickupPhysicalAddress: "",
  pickupContactName: "",
  pickupContactPhone: "",
  pickupContactEmail: "",
  pickupStopName: "",
  pickupDate: moment().add(1, "d"),
  dropoffAddress: "",
  dropoffPhysicalAddress: "",
  dropoffContactName: "",
  dropoffContactPhone: "",
  dropoffStopName: "",
  packageTypeId: "",
  note: "",
  quantity: 1
};
